import React, { useRef, useState,} from "react";
import { connect } from "react-redux";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { searchReviews } from "../../actions/reviewAction";
import {
  Popup,
  //Button,
} from "semantic-ui-react";
import{ imageDomain} from "../configC/keys"
import {
  formatDuration,
  intervalToDuration,
  // format,
} from "date-fns";
import {bgColor} from "../functions/Functions"
import ModalGr from "../modalGr/Modal";
import ReviewList from "./ReviewList";
import ReactPlayer from "react-player/youtube";

const WhatClientSay = (props) => {
  const [state, setState] = useState({
     play: true, 
     stop: false, 
     openM: false,
    });

  
  const openModal = () => {
    setState({ ...state, openM: true ,});
    // to stop scrolling of body content
    document.body.style.overflow = "hidden";
    // window.scroll(0, 0);
  };
  const closeModal = () => {
    // to start scrolling of body content
    document.body.style.overflow = "auto";
    setState({ ...state, openM: false }); 
  };
  // *** show play or stop button of slider control
  const activePlay = () => {
    setState({ ...state, play: true, stop: false });
  };
  // *** show play or stop button of slider control
  const activeStop = () => {
    setState({ ...state, play: false, stop: true });
  };

  const renderPopupState = () => {
    if (window.innerWidth < 600) {
      return true;
    }
    if (window.innerWidth > 600) {
      return false;
    }
  };
  // ******
  const days = (value) => {
    let duration = intervalToDuration({
      start: new Date(value),
      end: new Date(),
    });
    const units = [
      "years",
      "months",
      "weeks",
      "days",
      // "hours",
      // "minutes",
      // "seconds",
    ];
    const nonzero = Object.entries(duration)
      .filter(([value]) => value || 0 > 0)
      .map(([unit]) => unit);
    //const nonzero = Object.entries(duration).filter(([_, value]) => value || 0 > 0).map(([unit, _]) => unit)

    return formatDuration(duration, {
      format: units.filter((i) => new Set(nonzero).has(i)).slice(0, 5),
      delimiter: ", ",
    });
  };
  // ******
  const settings = {
    autoplay: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 700,
    // initialSlide: 0,
    arrows: false,
    responsive: [
      // {
      //   breakpoint: 1024,
      //   settings: {
      //     slidesToShow: 3,
      //     slidesToScroll: 1,
      //     infinite: true,
      //     dots: true
      //   }
      // },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          // initialSlide: 2
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  let sliderRef = useRef(null);

  const next = () => {
    sliderRef.slickNext();
  };
  const previous = () => {
    sliderRef.slickPrev();
  };
  const play = () => {
    sliderRef.slickPlay();
    activePlay();
  };
  const pause = () => {
    sliderRef.slickPause();
    activeStop();
  };
  //*************** */

  const renderPlayStopButton = () => {
    if (state.play) {
      return (
        <Popup
          content={"Stop"}
          disabled={renderPopupState()}
          trigger={
            <span className="icon-button-gr" onClick={pause}>
              <img
                src="/stop.png"
                alt=" "
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "5px",
                  verticalAlign: "middle",
                }}
              />
            </span>
          }
        />
      );
    }
    if (state.stop) {
      return (
        <Popup
          content={"Play"}
          disabled={renderPopupState()}
          trigger={
            <span className="icon-button-gr" onClick={play}>
              <img
                src="/play.png"
                alt=" "
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "5px",
                  verticalAlign: "middle",
                }}
              />
            </span>
          }
        />
      );
    }
  };

  
  //*************** */
  const renderList = (reviews) => {
    const {name, phone, rating, review,reviewType,videoPath, img, createdAt, _id } = reviews;

    return (
      <div key={_id} className="card-review bgColor-gr direction-c">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            padding: "5px",
          }}
        >
          <div>
            {img && <img className="img-border-bg imgDimention-review" 
               src={`${imageDomain}${img}`} 
            />}
            {!img &&  <span className="firstchar-card flex-center"
            style={{backgroundColor:bgColor(5)}}
            >{name.charAt(0).toUpperCase()}</span> 
            }
          </div>
          <div style={{ marginLeft: "10px", paddingLeft: "10px" }}>
            <div className="font-20B textAlign-left">{name}</div>
           {/* {phone && <div className="font-16B textAlign-left">{phone}</div>} */}
            <div style={{ display: "flex" }}>
              {" "}
              {[...Array(rating)].map((e, i) => (
                <img
                style={{paddingLeft:'3px',borderRadius:'5px'}}
                  key={i}
                  src={`${imageDomain}/upload/mis/goldStar15.jpg`}
                />
              ))}
            </div>
            <div className="font-16 textAlign-left">{days(createdAt)?`${days(createdAt)} ago` :'Today'}</div>
          </div>
        </div>
        <div>
        {reviewType === 'Text' && <p className="font-16">{review}</p>}
        {reviewType === 'Video' && <div className="player-wrapper">
            <ReactPlayer
            light={true}
              //playing
              controls={true}
              className="react-player"
              url={videoPath}
              width="100%"
              height="100%"
            />
          </div>}
        </div>
      </div>
      // </div>
    );
  };

  

  //*************** */
  return (
    <section className="padding-gr-outer bgColor-gr ">
      <div className="inner-gr bgColor-gr">
        {/* 30year exp block */}
        {/* <div className="aboutimage">

<div className="about_exp_inner_upper flex-center">
<div className="about_exp_inner text-center font-family-Cooper">
<span className="counter"
style={{fontWeight:'1200'}}
>30</span>
<h2>Years of Experience</h2>
</div>
</div>

</div> */}
        <div className="headtitl">
          <div className="line-height-gr font-36B color-CornflowerBlue px-20">
            What Our <span>Client Says</span>
          </div>
          <div className="font-18B px-20 ">
            <p>Come with your dreams..we are here to give them wings.</p>
          </div>
          <div className="devider"></div>
        </div>

        {/*  */}
        <div
          style={{ margin: "auto", maxWidth: "1140px" }}
          className="slider-container"
        >
          <Slider
            ref={(slider) => {
              sliderRef = slider;
            }}
            {...settings}
          >
            {props.state.reviews.reviews.map((item) => renderList(item))}
          </Slider>

          <div className="flex-center" style={{ textAlign: "center" }}>
            <Popup
              content={"Previous"}
              disabled={renderPopupState()}
              trigger={
                <span className="icon-button-gr" onClick={previous}>
                  <img
                    src="/pre.png"
                    alt=" "
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "5px",
                      verticalAlign: "middle",
                    }}
                  />
                </span>
              }
            />

            {renderPlayStopButton()}
            <Popup
              content={"Next"}
              disabled={renderPopupState()}
              trigger={
                <span className="icon-button-gr" onClick={next}>
                  <img
                    src="/next.png"
                    alt=" "
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "5px",
                      verticalAlign: "middle",
                    }}
                  />
                </span>
              }
            />
            <button
              className=" padding-button border-outline"
              style={{ background: "cornflowerblue", cursor: "pointer" }}
              onClick={openModal}
            >
              View All
            </button>
          </div>
        </div>

        {/*  */}
      </div>
      <div>
       {state.openM && <ModalGr
          hasCloseBtn={true}
          isOpen={state.openM}
          onClose={closeModal}
          className={"modal-review body"}
        >
         <ReviewList
          closeModal={closeModal}
          />
        </ModalGr>}
        
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  
  return {
    state,
  };
};

// export default WhatClientSay;
export default connect(mapStateToProps, { searchReviews })(WhatClientSay);
